// Next.js replaces process.env.NEXT_PUBLIC_* at build time only for direct access
// Dynamic access like process.env[name] won't work on the client side
// This file provides a workaround by explicitly listing all public env vars

const publicEnvVars: Record<string, string | undefined> = {
  NEXT_PUBLIC_COOKIE_SECURE: process.env.NEXT_PUBLIC_COOKIE_SECURE,
  NEXT_PUBLIC_HUBSPOT_PORTAL_ID: process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID,
  NEXT_PUBLIC_HUBSPOT_CONTACT_FORM_ID_EN: process.env.NEXT_PUBLIC_HUBSPOT_CONTACT_FORM_ID_EN,
  NEXT_PUBLIC_HUBSPOT_CONTACT_FORM_ID_JA: process.env.NEXT_PUBLIC_HUBSPOT_CONTACT_FORM_ID_JA,
  NEXT_PUBLIC_TERMS_OF_USE_EN: process.env.NEXT_PUBLIC_TERMS_OF_USE_EN,
  NEXT_PUBLIC_TERMS_OF_USE_JA: process.env.NEXT_PUBLIC_TERMS_OF_USE_JA,
  NEXT_PUBLIC_GET_TOKEN_URL: process.env.NEXT_PUBLIC_GET_TOKEN_URL,
  NEXT_PUBLIC_DEVELOPMENT_PROGRAM_SERVICE_URL:
    process.env.NEXT_PUBLIC_DEVELOPMENT_PROGRAM_SERVICE_URL,
  NEXT_PUBLIC_ENDPOINT_SERVICE_SERVICE_URL: process.env.NEXT_PUBLIC_ENDPOINT_SERVICE_SERVICE_URL,
  NEXT_PUBLIC_CUSTOM_SCHEMA_URL: process.env.NEXT_PUBLIC_CUSTOM_SCHEMA_URL,
  NEXT_PUBLIC_API_EIP721_SUBGRAPH_SERVER: process.env.NEXT_PUBLIC_API_EIP721_SUBGRAPH_SERVER,
  NEXT_PUBLIC_IPFS_GATEWAY_URL: process.env.NEXT_PUBLIC_IPFS_GATEWAY_URL,
  NEXT_PUBLIC_JOC_URL: process.env.NEXT_PUBLIC_JOC_URL,
  NEXT_PUBLIC_JOC_TESTNET_URL: process.env.NEXT_PUBLIC_JOC_TESTNET_URL,
  NEXT_PUBLIC_TOKEN_ADDRESS: process.env.NEXT_PUBLIC_TOKEN_ADDRESS,
  NEXT_PUBLIC_EXPLORER_URL: process.env.NEXT_PUBLIC_EXPLORER_URL,
  NEXT_PUBLIC_NFT_AUTH_URL: process.env.NEXT_PUBLIC_NFT_AUTH_URL,
  NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID: process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
  NEXT_PUBLIC_JOC_CHAIN_ID: process.env.NEXT_PUBLIC_JOC_CHAIN_ID,
  NEXT_PUBLIC_JOC_TESTNET_CHAIN_ID: process.env.NEXT_PUBLIC_JOC_TESTNET_CHAIN_ID,
  NEXT_PUBLIC_SEED_CONTRACT_ADDRESS: process.env.NEXT_PUBLIC_SEED_CONTRACT_ADDRESS,
  NEXT_PUBLIC_SPROUT_CONTRACT_ADDRESS: process.env.NEXT_PUBLIC_SPROUT_CONTRACT_ADDRESS,
  NEXT_PUBLIC_HARVEST_CONTRACT_ADDRESS: process.env.NEXT_PUBLIC_HARVEST_CONTRACT_ADDRESS,
  NEXT_PUBLIC_API_LENDING_SEED_SUBGRAPH_SERVER:
    process.env.NEXT_PUBLIC_API_LENDING_SEED_SUBGRAPH_SERVER,
  NEXT_PUBLIC_API_LENDING_SPROUT_SUBGRAPH_SERVER:
    process.env.NEXT_PUBLIC_API_LENDING_SPROUT_SUBGRAPH_SERVER,
  NEXT_PUBLIC_API_LENDING_HARVEST_SUBGRAPH_SERVER:
    process.env.NEXT_PUBLIC_API_LENDING_HARVEST_SUBGRAPH_SERVER,
  NEXT_PUBLIC_SUBGRAPH_API_KEY: process.env.NEXT_PUBLIC_SUBGRAPH_API_KEY,
  NEXT_PUBLIC_USDTX_CONTRACT_ADDRESS: process.env.NEXT_PUBLIC_USDTX_CONTRACT_ADDRESS,
  NEXT_PUBLIC_X_GATE_URL: process.env.NEXT_PUBLIC_X_GATE_URL,
  NEXT_PUBLIC_JOC_RESOURCE_BASE_URL: process.env.NEXT_PUBLIC_JOC_RESOURCE_BASE_URL,
  // Staking
  NEXT_PUBLIC_STAKING_SUBGRAPH_URL: process.env.NEXT_PUBLIC_STAKING_SUBGRAPH_URL,
  NEXT_PUBLIC_STAKING_IS_TESTNET: process.env.NEXT_PUBLIC_STAKING_IS_TESTNET,
  NEXT_PUBLIC_ETHEREUM_RPC_URL: process.env.NEXT_PUBLIC_ETHEREUM_RPC_URL,
  // Feature flags
  NEXT_PUBLIC_FEATURE_JOC_CLUB_ENABLED: process.env.NEXT_PUBLIC_FEATURE_JOC_CLUB_ENABLED,
  NEXT_PUBLIC_FEATURE_STAKING_ENABLED: process.env.NEXT_PUBLIC_FEATURE_STAKING_ENABLED,
  NEXT_PUBLIC_JOC_CLUB_CONTRACT_ADDRESS: process.env.NEXT_PUBLIC_JOC_CLUB_CONTRACT_ADDRESS,
  // Admin
  NEXT_PUBLIC_ADMIN_ADDRESSES: process.env.NEXT_PUBLIC_ADMIN_ADDRESSES,
  // Firebase
  NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  NEXT_PUBLIC_FIREBASE_PROJECT_ID: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  NEXT_PUBLIC_FIREBASE_EMULATOR: process.env.NEXT_PUBLIC_FIREBASE_EMULATOR,
  NEXT_PUBLIC_FIRESTORE_DATABASE_ID: process.env.NEXT_PUBLIC_FIRESTORE_DATABASE_ID,
};

export const getEnv = (name: string): string | undefined => {
  // For NEXT_PUBLIC_* vars, use the pre-resolved map (works on client side)
  if (name.startsWith('NEXT_PUBLIC_')) {
    return publicEnvVars[name];
  }
  // For server-side only vars, use dynamic access
  return process.env[name];
};
